import React from 'react'

import type { WaveLinkHeaderProps } from 'routes/Menu/MenuRecipesPage/CollectionHeader/WaveLinkHeader/WaveLinkHeader'

import { WaveLinkHeader } from '../WaveLinkHeader'
import { useWaveLinkHeaderClick } from './useWaveLinkHeaderClick'

const WaveLinkHeaderContainer = (props: Omit<WaveLinkHeaderProps, 'onClick'>) => {
  const { link } = props
  const onClick = useWaveLinkHeaderClick(link?.collectionId, link?.collectionSlug)

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <WaveLinkHeader {...props} onClick={onClick} />
}

export { WaveLinkHeaderContainer }
